import { Rule } from 'antd/lib/form'

import { SignatureCaptureBlock as SignatureCaptureBlockType } from '../../types/blueprint'

import { CaptureBlockFormItem } from './CaptureBlockFormItem'

import {
  SignatureAttachmentUploader,
  SignatureData,
} from '@/components/form-components/SignatureAttachmentUploader'
import { useTemplateRenderer } from '@/context/templateRendererContext'

type Props = {
  block: SignatureCaptureBlockType
  rules: Rule[]
}

export const SignatureCaptureBlock: React.FC<Props> = ({ block, rules }) => {
  const { projectId, resource } = useTemplateRenderer()

  const initialValue: SignatureData = {
    signee: block.signeeName,
    key: block.key,
    url: block.url,
    time: new Date(block.time),
    attachmentId: block.attachmentId,
  }

  return (
    <CaptureBlockFormItem
      block={block}
      initialValue={initialValue}
      rules={rules}
    >
      <SignatureAttachmentUploader projectId={projectId} resource={resource} />
    </CaptureBlockFormItem>
  )
}
